(function () {
  'use strict';

  const sectionColors = document.querySelector('.main-product__colors');
  document.querySelector('#breadcrumbs_collection');
  if (sectionColors) {
    (function sameType() {
      const colorCode = sectionColors.dataset.color;
      const id = sectionColors.dataset.id;
      fetch(`/search/suggest.json?q="${colorCode}"&resources[type]=product&resources[limit]=10&resources[options][fields]=tag`).then(response => response.json()).then(result => {
        const products = result.resources.results.products;
        if (products.length > 1) {
          products.forEach((product, index) => {
            if (product.id !== +id) {
              document.querySelector('.main-product__colors-list').innerHTML += `
            <li class="main-product__colors-item">
              <a href="/products/${product.handle}" class="main-product__colors-link">
                <img src="${product.featured_image.url}" alt="${product.title}" width="${product.featured_image.width}" height="${product.featured_image.height}" loading="lazy" class="lazyload">
              </a>
            </li>`;
            }
          });
          sectionColors.style.display = 'block';
        }
      });
    })();
  }

  // const createBreadcrumbs = () => {
  //   console.log('previous url ', document.referrer);
  //   breadcrumbs.innerText = document.referrer;
  //   breadcrumbs.style.display = 'block';
  // };

  // createBreadcrumbs();

})();
